import { useQuery } from 'react-query';

import { apiLambda } from '../services/apiLambda';

const basePathDash = 'frotas/dash';
const basePathDashYearly = 'frotas/dash-annual';

type VehicleDebts = {
  value: number;
  count: number;
  countWithDebts: number;
  countWithoutDebts: number;
  countWithoutConsults: number;
};

type VehicleCountByUF = {
  uf: string;
  value: number;
  debtCount: number;
  vehicleCount: number;
  hasConsults: boolean;
};

type FinesCount = {
  value: number;
  count: number;
  average: number;
};

type FinesRanking = {
  id: number;
  name?: string;
  placa: string;
  value: number;
  count: number;
};

type LicensingStatusCount = {
  licensed: number;
  notLicensed: number;
  availableForLicensing: number;
  undefined: number;
};

interface IConsultaServices {
  consulta: string;
  subUsuario: string;
  serviceId: number;
  payloadService: any;
  retornoConsulta: any;
  idUserVehicle?: number;
  retryCount?: number;
  issueYear?: number;
  statusPagamento:
    | 'Consulta'
    | 'PROCESSAMENTO'
    | 'APROVADO'
    | 'NEGADO'
    | 'LIQUIDADO';
}

interface IVehicle {
  placa: string;
  renavam: string;
  uf: string;
  municipio: string;
  chassi: string;
  tipo: string;
  marca: string;
  ano: number;
  importado: boolean;
  invalid: boolean;
}

interface IUserVehicle {
  id: number;
  sub: string;
  nickname?: string;
  vehicle?: IVehicle;
  idVehicle: number;
  document?: string;
  uf?: string;
  renavam?: string;
  vehicleType?: string;
  showNotification: boolean;
  isSpecial: boolean;
  consultaServices?: IConsultaServices[];
  fipe?: any;
  hasCrlvCoolDown: boolean;
  created_at: Date;
  updated_at: Date;
  deleted_at?: Date;
}

interface IConsult {
  consulta: string;
  correlation: string;
  subUsuario?: string;
  userPool?: string;
  dataConsulta?: any;
  placa?: string;
  renavam?: string;
  payloadConsulta?: any;
  payloadCaptura?: any;
  payloadComprovante?: any;
  status?: string;
  ip?: string;
  email?: string;
  origin?: string;
  subStatus?: string;
  subStatusLastUpdated?: Date;
  idApiKey?: number;
}
interface IGetFrotasVehicleAndDebtsResponse {
  vehicleDebts: VehicleDebts;
  vehicleDataByUF: VehicleCountByUF[];
  finesCount: FinesCount;
  licensingStatusCount: LicensingStatusCount;
  vehicleRankingByFines: FinesRanking[];
  totalUserVehicles: number;
  userVehicles: IUserVehicle[];
  consults: IConsult[];
}

interface IPagedParams {
  startDate?: string | Date;
  endDate?: string | Date;
  uf?: string;
  vehicleType?: string;
}

export async function listDashInfos(
  params: IPagedParams,
): Promise<IGetFrotasVehicleAndDebtsResponse> {
  const { data } = await apiLambda.get(basePathDash, { params });

  return data.data;
}

export async function listDashInfosYearly(): Promise<any> {
  const { data } = await apiLambda.get(basePathDashYearly);

  return data.data;
}

export function useDashInfos(params: IPagedParams) {
  const queryKey = [
    basePathDash,
    params.startDate,
    params.endDate,
    params.uf,
    params.vehicleType,
  ];

  return useQuery(queryKey, () => listDashInfos(params), {
    staleTime: 30000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export function useDashInfosYearly() {
  return useQuery(basePathDash, () => listDashInfosYearly(), {
    staleTime: 550000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
